import { CALCULATE_FINANCE_PAYMENTS } from './calculateFinancePayments';

export const lenderDeskingApi = {
  calculate: CALCULATE_FINANCE_PAYMENTS,
};
